import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
//import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { FileUpload } from "primereact/fileupload";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getDataArchivoToJson } from "../../../../../../Base/Services/ArchivosService";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getDateTimeSQL3 } from "../../../../../../Base/Services/FechasService";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ModalEtiquetaQR from "../../../../Global/Productos/Reporte/ModalEtiquetaQR";
import OverlayUbicacionPacas from "../OverlayPanels/UbicacionPacasOverlayPanel";

// ------------------- CONSULTAS A LA API---------------------------
import {
  getEstantesAct,
  getPosicionesAct,
  getBandejasActivas,
} from "../../../../../../API/Suministros/SuministrosRequest";
import {
  postGuardarPacas,
  getPacas,
  UpdateGuardarPacas,
  DeletePacas,
} from "../../../../../../API/Suministros/IngresosBodega/ArchivoPacasRequest";

const ModalPacas = ({
  visible,
  onHide,
  detalleIngreso,
  proveedor,
  NoIngreso,
  Factura,
  FechaFactura,
}) => {
  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [listadoDetalles, setListadoDetalles] = useState([]);
  const [showEtiqueta, setShowEtiqueta] = useState(false);
  const [selectedPacas, setSelectedPacas] = useState([]);
  const [selected, setSelected] = useState([]);

  const [estantes, setEstantes] = useState([]);
  const [filas, setFilas] = useState([]);
  const [posiciones, setPosiciones] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);

  // Función para abrir el overlay de ubicación al editar las columnas de Estante, Fila o Bandeja
  const changeUbicacion = ({ data, api }) => {
    const puedeEditarUbicacion = data?.IdPaca === -1 || modoEdicion;

    return (
      <OverlayUbicacionPacas
        rowData={data}
        rowKey={data.IdPaca > 0 ? data.IdPaca : data.GinBale}
        estantes={estantes}
        filas={filas}
        posiciones={posiciones}
        listadoDetalles={listadoDetalles}
        disabled={!puedeEditarUbicacion}
        onChange={cambiarUbicacionPacas}
        onToast={(severity, summary, detail) =>
            toastShow(toast, severity, summary, detail)
        }
        onReloadUbicaciones={cargarUbicaciones}
        api={api}
      />
    );
  };

  const table = {
    Data: listadoDetalles,
    Columns: [
      {
        field: "IdPaca",
        header: "IdPaca",
        className: "small",
        hidden: userAuth.IdRol === 1,
        frozen: "true",
        alignFrozen: "left",
      },
      {
        field: "StatusName",
        header: "Estado",
        className: "small",
        Format: "Estado",
        body: (rowData) => ({
          ID: rowData?.IdStatus,
          Estado: rowData?.StatusName,
        }),
        alignFrozen: "left",
      },
      {
        field: "Correlativo",
        header: "Correlativo",
        className: "small",
        frozen: "true",
        alignFrozen: "left",
        Format: "Template",
        body: (rowData) => {
          if (!rowData?.IdPaca || rowData.IdPaca === -1) {
            return "";
          }

          const anio = FechaFactura
            ? new Date(FechaFactura)
                .getFullYear()
                .toString()
                .slice(-2)
            : "";

          return `${anio}-${String(rowData.IdPaca).padStart(4, "0")}`;
        },
      },
      {
        field: "GinBale",
        header: "GinBale",
        className: "small",
        Sumary: "count",
        frozen: "true",
        alignFrozen: "left",
      },
      {
        field: "IdDetalleIngresoBodega",
        header: "IdDetalleIngresoBodega",
        className: "small",
        hidden: userAuth.IdRol === 1,
      },
      // Cargar la Fecha
      {
        field: "Fecha",
        header: "Fecha",
        className: "small",
        hidden: userAuth.IdRol === 1,
      },
      {
        field: "Usuario",
        header: "Usuario",
        className: "small",
        hidden: userAuth.IdRol === 1,
      },
      {
        field: "GinCode",
        header: "GinCode",
        className: "small",
      },
      {
        field: "WhseReceipt",
        header: "WhseReceipt",
        className: "small",
      },
      {
        field: "Grd",
        header: "Grd",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Leaf",
        header: "Leaf",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Stpl",
        header: "Stpl",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Mic",
        header: "Mic",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Str",
        header: "Str",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Len",
        header: "Len",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Uni",
        header: "Uni",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Rd",
        header: "Rd",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Mas_b",
        header: "Mas_b",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },

      {
        field: "ColdCd",
        header: "ColdCd",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Qd",
        header: "Qd",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Trsh",
        header: "Trsh",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Mark",
        header: "Mark",
        className: "small",
      },
      {
        field: "Gross",
        header: "Gross",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Tare",
        header: "Tare",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
      },
      {
        field: "Net",
        header: "Net Lbs",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
        alignFrozen: "right",
      },
      {
        field: "PesoNeto",
        header: "Kgs",
        headerEn: "",
        className: "small",
        Format: "Currency",
        Sumary: "sum",
        alingn: true,
        alignFrozen: "right",
        editable: modoEdicion,
      },
      // Columnas de ubicación (Estante, Fila, Bandeja)
      {
        field: "EstanteDisplay",
        header: "Estante",
        className: "small",
        frozen: true,
        alignFrozen: "right",
        editable: (params) => params.data?.IdPaca === -1 || modoEdicion,
        cellEditor: changeUbicacion,
        body: (rowData) => rowData.EstanteDisplay || "",
      },
      {
        field: "FilaDisplay",
        header: "Fila",
        className: "small",
        frozen: true,
        alignFrozen: "right",
        editable: (params) => params.data?.IdPaca === -1 || modoEdicion,
        cellEditor: changeUbicacion,
        body: (rowData) => rowData.FilaDisplay || "",
      },
      {
        field: "BandejaDisplay",
        header: "Posición",
        className: "small",
        frozen: true,
        alignFrozen: "right",
        editable: (params) => params.data?.IdPaca === -1 || modoEdicion,
        cellEditor: changeUbicacion,
        body: (rowData) => rowData.BandejaDisplay || "",
      },
      // Columna para imprimir etiqueta QR
      {
        header: "",
        field: "EtiquetaQR",
        Format: "Template",
        className: "XXsmall",
        filter: false,
        frozen: "true",
        alignFrozen: "right",
        body: (rowData) => (
          <div className="d-flex justify-content-center align-items-center">
            <Button
              icon="pi pi-qrcode"
              className="p-button-text p-button-info"
              tooltip="Imprimir Etiqueta QR"
              tooltipOptions={{ position: "top" }}
              disabled={rowData?.IdPaca === -1}
              onClick={() => {
                setSelectedPacas([rowData]);
                setShowEtiqueta(true);
              }}
            />
          </div>
        ),
      },
    ],
    selected: selected,
    setSelected: setSelected,
  };

  const fecha = getDateTimeSQL3(new Date());

  const GenerarDataExcel = async (event) => {
    setLoading(true);
    const file = event.files[0];

    try {
      const jsonData = await getDataArchivoToJson(file);
      const nombrePrimeraHoja = Object.keys(jsonData)[0];
      const Hoja = jsonData[nombrePrimeraHoja];

      if (Hoja?.length > 0) {
        let tempoDet = [];

        Hoja.forEach((fila) => {
          tempoDet.push({
            IdPaca: -1,
            IdDetalleIngresoBodega: detalleIngreso?.IdIngresoDetalle,
            FechaCreate: fecha,
            IdUserCreate: userAuth?.IdUser,
            TipoSeleccion: null,
            TipoSeleccionNombre: "",
            GinBale: fila["Gin Bale#"],
            GinCode: fila["Gin Code"],
            WhseReceipt: fila["Whse Receipt"],
            Grd: fila["Grd"],
            Leaf: fila["Leaf"],
            Stpl: fila["Stpl"],
            Mic: fila["Mic"],
            Str: fila["Str"],
            Len: fila["Len"],
            Uni: fila["Uni"],
            Rd: fila["Rd"],
            Mas_b: fila["+b"],
            ColdCd: fila["ColCd"],
            Qd: fila["Qd"],
            Trsh: fila["Trsh%"],
            Mark: fila["Mark"],
            IdEstante: null,
            NumeroEstante: "",
            IdPosicion: null,
            NumeroPosicion: "",
            IdBandeja: null,
            NumeroBandeja: "",
          });
        });

        setListadoDetalles(tempoDet);
        toastShow(
          toast,
          "success",
          "Éxito",
          `${tempoDet.length} registros cargados`,
        );
      } else {
        toastShow(toast, "warn", "Advertencia", "El archivo no contiene datos");
      }

      fileUploadRef?.current?.clear();
      // setSelectedFile(null)
    } catch (error) {
      toastShow(toast, "error", "Error", `Error al leer el archivo: ${error}`);
    }

    setLoading(false);
  };

  const GenerarDataExcel2 = async (event) => {
    setLoading(true);
    const file = event.files[0];

    try {
      const jsonData = await getDataArchivoToJson(file);
      const nombrePrimeraHoja = Object.keys(jsonData)[0];
      const Hoja = jsonData[nombrePrimeraHoja];

      if (Hoja?.length > 0) {
        // const ginBalesExistentes = listadoDetalles.map((d) => d.GinBale);
        const ginBalesExistentes = listadoDetalles.map((d) =>
          Number(d.GinBale)
        );
        const sinMatch = Hoja.filter((fila) => {
          return !ginBalesExistentes.includes(Number(fila["Gin Bale#"]));
        });

        if (sinMatch.length > 0) {
          const ginBalesFaltantes = sinMatch
            .map((f) => f["Gin Bale#"])
            .join(", ");
          toastShow(
            toast,
            "error",
            "Error",
            `Los siguientes GinBale no coinciden con los datos existentes: ${ginBalesFaltantes}`,
          );
          fileUploadRef?.current?.clear();
          // setSelectedFile2(null)
          setLoading(false);
          return;
        }

        const updatedList = listadoDetalles.map((detalle) => {
          const filaMatch = Hoja.find(
            (fila) => Number(fila["Gin Bale#"]) === Number(detalle.GinBale),
          );
          if (filaMatch) {
            return {
              ...detalle,
              Gross: filaMatch["Gross"] ?? detalle.Gross,
              Tare: filaMatch["Tare"] ?? detalle.Tare,
              Net: filaMatch["Net"] ?? detalle.Net,
              PesoNeto: detalle.PesoNeto
                ? detalle.PesoNeto
                : filaMatch["Net"]
                  ? parseFloat((filaMatch["Net"] * 0.453592).toFixed(2))
                  : null,
            };
          }
          return detalle;
        });

        setListadoDetalles(updatedList);
        toastShow(
          toast,
          "success",
          "Éxito",
          "Datos de pesos cargados correctamente",
        );
      } else {
        toastShow(toast, "warn", "Advertencia", "El archivo no contiene datos");
      }

      fileUploadRef?.current?.clear();
      setSelectedFile2(null);
    } catch (error) {
      toastShow(toast, "error", "Error", `Error al leer el archivo: ${error}`);
    }

    setLoading(false);
  };

  const GuardarInformacion = async () => {
    if (listadoDetalles.length === 0) {
      toastShow(toast, "error", "Error", "Debe cargar un archivo primero");
      return;
    }

    const yaGuardados = listadoDetalles.some((d) => d.IdPaca > 0);

    confirmDialog({
      message: "¿Está seguro que desea guardar la información?",
      header: "Confirmar",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setLoading(true);

        const result = yaGuardados
          ? await UpdateGuardarPacas(listadoDetalles)
          : await postGuardarPacas(listadoDetalles);

        if (result && result[0]?.ESTADO !== -1) {
          toastShow(
            toast,
            "success",
            "Guardado",
            result[0]?.MENSAJE || "Información guardada correctamente.",
          );

          setTimeout(() => {
            setListadoDetalles([]);
            onHide();
          }, 1000);
        } else {
          toastShow(
            toast,
            "error",
            "Error",
            result?.[0]?.MENSAJE || "No se pudo guardar la información.",
          );
        }

        setLoading(false);
      },
      reject: () => {},
    });
  };

  const onFileSelect = (e) => {
    if (e.files && e.files.length > 0) {
      setSelectedFile(e?.files[0]?.name);
      GenerarDataExcel(e);
    }
  };

  const EliminarArchivo = () => {
    fileUploadRef?.current?.clear();
    setSelectedFile(null);
    setListadoDetalles([]);
    setSelected([]);
  };

  const LimpiarDatos = () => {
    setListadoDetalles([]);
    setSelected([]);
    setSelectedFile(null);
    setSelectedFile2(null);
    setModoEdicion(false);
    fileUploadRef?.current?.clear();
  };

  const normalizarPacas = (data = []) => {
    return data.map((item) => ({
      ...item,
      EstanteDisplay: item.NombreEstante || "",
      FilaDisplay: item.NombrePosicion || "",
      BandejaDisplay: item.NombreBandeja
        ? item.Lado
          ? `${item.NombreBandeja} - ${item.Lado}`
          : item.NombreBandeja
        : "",
    }));
  };

  useEffect(() => {
    if (visible && detalleIngreso?.IdIngresoDetalle) {
      setModoEdicion(false);
      setSelected([]);

      cargarUbicaciones();
      cargarPacas();
    }

    if (!visible) {
      LimpiarDatos();
    }
  }, [visible, detalleIngreso?.IdIngresoDetalle]);

  const cargarPacas = async () => {
    const idIngresoDetalle = detalleIngreso?.IdIngresoDetalle;
    if (!idIngresoDetalle) {
      return;
    }
    setLoading(true);

    try {
      const result = await getPacas(idIngresoDetalle);

      if (Array.isArray(result) && result.length > 0) {
        const datosNormalizados = normalizarPacas(result);
        setListadoDetalles(datosNormalizados);
      } else {
        setListadoDetalles([]);
      }
    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "[PACAS] Error cargando pacas:", error
      );
    } finally {
      setLoading(false);
    }
  };

  const imprimirQRSeleccionados = () => {
    if (selected.length === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione al menos un registro para imprimir.",
      );
      return;
    }

    if (selected.length > 20) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Solo puede imprimir máximo 20 etiquetas a la vez.",
      );
      return;
    }

    const noGuardados = selected.some((item) => item.IdPaca === -1);

    if (noGuardados) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Primero debe guardar los registros antes de imprimir QR.",
      );
      return;
    }

    setSelectedPacas(selected);
    setShowEtiqueta(true);
  };

  const eliminarSeleccionados = () => {
    if (selected.length === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione al menos un registro para eliminar.",
      );
      return;
    }

    confirmDialog({
      message: `¿Está seguro que desea eliminar ${selected.length} registro(s) seleccionado(s)?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const yaGuardados = selected.filter((item) => item.IdPaca > 0);

        if (yaGuardados.length > 0) {
          setLoading(true);
          const result = await DeletePacas(yaGuardados);
          setLoading(false);

          if (!result) {
            toastShow(toast, "error", "Error", "Ocurrió un error al eliminar.");
            return;
          }
        }

        const nuevosDatos = listadoDetalles.filter(
          (item) => !selected.some((sel) => sel.GinBale === item.GinBale),
        );

        setListadoDetalles(nuevosDatos);
        setSelected([]);
        toastShow(
          toast,
          "success",
          "Eliminado",
          "Registros eliminados correctamente.",
        );
      },
      reject: () => {},
    });
  };

  const tieneValor = (valor) => {
    return valor !== null && valor !== undefined && valor !== "";
  };

  const tienePacasRegistradas = listadoDetalles.some((item) => item.IdPaca > 0);
  const tienePesosRegistrados = listadoDetalles.some(
    (item) =>
      tieneValor(item.Gross) && tieneValor(item.Tare) && tieneValor(item.Net),
  );

  // Cargar datos de ubicaciones para dropdowns
  const cargarUbicaciones = async () => {
    const estantesTempo = await getEstantesAct();
    const filasTempo = await getPosicionesAct();
    const posicionesTempo = await getBandejasActivas();

    const estantesMateriaPrima = (estantesTempo || []).filter(
      (item) => item.NombreBodega?.trim().toLowerCase() === "materia prima",
    );

    setEstantes([...estantesMateriaPrima]);
    setFilas([...(filasTempo || [])]);
    setPosiciones([...(posicionesTempo || [])]);

    return {
      estantes: estantesMateriaPrima,
      filas: filasTempo || [],
      posiciones: posicionesTempo || [],
    };
  };

  // Función para actualizar la ubicación (estante, fila, bandeja) de una paca
  const cambiarUbicacionPacas = ({ rowKey, estante, fila, posicion }) => {
    const idBandejaSeleccionada = posicion?.IdBandeja;
    const bandejaYaUsada = listadoDetalles.some((item) => {
      const itemKey = item.IdPaca > 0 ? item.IdPaca : item.GinBale;

      return (
        itemKey !== rowKey &&
        Number(item.IdBandeja) === Number(idBandejaSeleccionada)
      );
    });

    if (bandejaYaUsada) {
      toastShow(
        toast,
        "warn",
        "Ubicación ocupada",
        "Esta bandeja ya fue seleccionada en este mismo archivo.",
      );
      return;
    }
    setListadoDetalles((prev) =>
      prev.map((item) => {
        const itemKey = item.IdPaca > 0 ? item.IdPaca : item.GinBale;

        if (itemKey !== rowKey) return item;
        return {
          ...item,
          IdEstante: estante?.IdEstante || null,
          EstanteDisplay: estante?.NombreEstante || "",

          IdPosicion: fila?.IdPosicion || null,
          FilaDisplay: fila?.NombrePosicion || "",

          IdBandeja: posicion?.IdBandeja || null,
          BandejaDisplay: posicion?.NombreBandeja
            ? posicion?.Lado
              ? `${posicion.NombreBandeja} - ${posicion.Lado}`
              : posicion.NombreBandeja
            : "",
        };
      }),
    );
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      style={{ width: "100vw", height: "100vh" }}
      header="Pacas"
    >
      <Toast ref={toast} />
      <Loader loading={loading} />

      {/* Barra de acciones */}
      <div
        className="d-flex pt-2"
        style={{ alignItems: "center", gap: "8px", flexWrap: "wrap" }}
      >
        {/* FileUpload */}
        <FileUpload
          ref={fileUploadRef}
          mode="basic"
          name="Pacas[]"
          accept=".xlsx, .xls, .XLSX, .XLS"
          chooseLabel="Seleccione un archivo"
          customUpload
          uploadHandler={GenerarDataExcel}
          onSelect={onFileSelect}
          style={{ alignSelf: "center" }}
          disabled={tienePacasRegistradas && !modoEdicion}
          className={tienePacasRegistradas && !modoEdicion ? "p-disabled" : ""}
        />
        {selectedFile && (
          <Button
            icon="pi pi-times"
            className="p-button-danger"
            style={{ height: 40 }}
            onClick={EliminarArchivo}
            tooltip="Quitar archivo"
            tooltipOptions={{ position: "top" }}
          />
        )}

        {/* FileUpload 2 - Pesos (Gross, Tare, Net) */}
        <FileUpload
          ref={fileUploadRef}
          mode="basic"
          name="Pacas2[]"
          accept=".xlsx, .xls, .XLSX, .XLS"
          chooseLabel="Cargar Pesos"
          customUpload
          uploadHandler={GenerarDataExcel2}
          onSelect={(e) => {
            if (e.files && e.files.length > 0) {
              setSelectedFile2(e?.files[0]?.name);
              GenerarDataExcel2(e);
            }
          }}
          //style={{ height: 40 }}
          style={{ alignSelf: "center" }}
          disabled={
            listadoDetalles.length === 0 ||
            !modoEdicion ||
            tienePesosRegistrados
          }
          className={
            listadoDetalles.length === 0 ||
            !modoEdicion ||
            tienePesosRegistrados
              ? "p-disabled"
              : ""
          }
        />
        {selectedFile2 && (
          <Button
            icon="pi pi-times"
            className="p-button-danger"
            style={{ backgroundColor: "#f12456", height: 40 }}
            onClick={() => {
              fileUploadRef?.current?.clear();
              setSelectedFile2(null);

              setListadoDetalles((prev) =>
                prev.map((item) => ({
                  ...item,
                  Gross: null,
                  Tare: null,
                  Net: null,
                })),
              );
            }}
            disabled={!modoEdicion && tienePesosRegistrados}
          />
        )}

        {/* Botones Refrescar, guardar y limpiar, Imprimir QR */}
        <Button
          icon="pi pi-refresh"
          tooltip="Refrescar Pacas"
          tooltipOptions={{ position: "top" }}
          style={{ alignSelf: "center" }}
          onClick={cargarPacas}
          disabled={!detalleIngreso?.IdIngresoDetalle || loading}
        />

        <Button
          icon="pi pi-save"
          style={{ alignSelf: "center" }}
          onClick={GuardarInformacion}
          disabled={listadoDetalles.length === 0}
          tooltip="Guardar"
          tooltipOptions={{ position: "top" }}
        />

        <Button
          icon="pi pi-pencil"
          style={{ alignSelf: "center" }}
          className={modoEdicion ? "p-button-warning" : "p-button-info"}
          onClick={() => setModoEdicion(!modoEdicion)}
          tooltip={modoEdicion ? "Desactivar edición" : "Editar"}
          tooltipOptions={{ position: "top" }}
        />

        <Button
          icon="pi pi-trash"
          style={{ alignSelf: "center" }}
          className="p-button-danger"
          onClick={eliminarSeleccionados}
          disabled={selected.length === 0 || !modoEdicion}
          tooltip="Eliminar seleccionados"
          tooltipOptions={{ position: "top" }}
        />

        <Button
          icon="pi pi-qrcode"
          style={{ alignSelf: "center" }}
          className="p-button-info"
          tooltip="Imprimir QR seleccionados"
          tooltipOptions={{ position: "top" }}
          onClick={imprimirQRSeleccionados}
          disabled={selected.length === 0}
        />
      </div>

      {/* Tabla */}
      <div className="pt-2" style={{ height: "75vh" }}>
        <AgGrid table={table} />
      </div>

      {/* Modal de etiqueta QR */}
      {showEtiqueta && (
        <ModalEtiquetaQR
          showEtiqueta={showEtiqueta}
          selected={selectedPacas}
          setShowEtiqueta={setShowEtiqueta}
          etiquetaQR={false}
          etiquetaPacas={true}
          proveedor={proveedor}
          NoIngreso={NoIngreso}
          Factura={Factura}
          FechaFactura={FechaFactura}
        />
      )}
    </Dialog>
  );
};

export default ModalPacas;
